import { createPinia } from "pinia";

export function createPiniaInstance() {
  return createPinia();
}
